import { computed } from 'vue';
import { useStore } from 'vuex';

export function useProtect({
  permissions = [],
  roles = [],
  skipProtect = false,
}) {
  const store = useStore();

  const externalRole = computed(
    () => store.getters['user/externalMemberships/getCurrentProjectRole']
  );

  const currentPermissions = computed(
    () => store.getters['permissions/getPermissions']
  );

  const hasPermission = computed(() => {
    if (skipProtect) {
      return true;
    }
    if (roles) {
      if (roles.includes(externalRole.value)) {
        return true;
      }
    }
    if (permissions) {
      if (Array.isArray(permissions)) {
        return permissions.some(permission =>
          currentPermissions.value?.includes?.(permission)
        );
      }
      if (currentPermissions.value) {
        return currentPermissions.value.includes(permissions);
      }
    }

    return false;
  });

  return { hasPermission };
}
